import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10.4 16.042a6.042 6.042 0 1 0 0-12.084 6.042 6.042 0 0 0 0 12.084Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12.275 7.292H9.88a1.354 1.354 0 1 0 0 2.708h1.041a1.354 1.354 0 0 1 0 2.708H8.525m1.875-6.25v.417m0 6.25v.417" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);